import React from 'react';
import { Pagination } from 'react-admin';

const AdminPagination = props => (
    <Pagination rowsPerPageOptions={[50, 100, 200]} {...props} />
);

export default AdminPagination;
